export default "__VITE_ASSET__be1a187b__"